import Enllac from 'components/3catinfo/Enllac';
import styles from './mostraMesResultats.module.scss';

const MostraMesResultats = (props) => {
    const { titol, link, linkTipus, slug, slug2, id } = props;

    const route = {
        href: link,
        type: linkTipus,
        slug: slug,
        slug2: slug2,
        id: id
    };

    if (!link && !linkTipus) return <></>;

    return (
        <Enllac route={route} className={styles.linkResultats} ariaLabel={titol} title={titol}>
            {titol}
        </Enllac>
    );
};

export default MostraMesResultats;
